export default "__VITE_ASSET__74f0defc__"